import HelmetTags from "./HelmetTags";

function NotFound() {
  <HelmetTags title="هذة الصفحة غير موجودة منفضلك عد الي الرئيسية" />;
  return <div className="w-full h-screen flex justify-center items-center">404 Page Not Found</div>;
}

export default NotFound;
